import { Component, OnInit ,ViewChild} from '@angular/core';
import { NgForm , FormGroup,FormControl,Validators } from '@angular/forms';
import { InterviewService } from './interview.service';
import { Observable } from "rxjs";


    @Component({
      selector: 'app-newinterviewreview',
      templateUrl: './newinterviewreview.component.html',
      styleUrls: ['./newinterviewreview.component.css']
    })
    export class NewinterviewreviewComponent implements OnInit {
  

  myform: FormGroup;
 
 
  email: FormControl;
  mobile_no: FormControl;
 
  


    genders=['Male','Female'];



 
     createFormControls() {
  
                    this.email = new FormControl('', [
                    Validators.required,
                    Validators.pattern("[^ @]*@[^ @]*")
                   ]);
                   this.mobile_no = new FormControl('', [
                   Validators.required,
                   Validators.minLength(10),
                    Validators.maxLength(10)
                  ]);  
   }



  createForm() {
      this.myform = new FormGroup({
     
      email: this.email,
      mobile_no:this.mobile_no 
    });
  }

public get_data = {};

   skills: Array<any> = [];
  public getdata: any = [];

       public userdata: any ={

                    username:'',
                    email:'',      
                    birthDate:'',
                    totalexp:'',
                    current_ctc:'',
                    expect_ctc:'',
                    notice_period:'',
                    skill1:'',
                    skill_rating2:'',
                    gender:'',
                    question1:'',
                    question2:''

          
        };
        submitted=false;

  constructor(private _service: InterviewService) 
    {
           
     
             
  } 

    ngOnInit() {

    this.createFormControls();
this.createForm() ;

  this._service.get_skills().subscribe(
       (data: any) =>{
         console.log(data);
          this.skills = data
      
       });


    }



    
    savedata(form: NgForm)
    {


    this.submitted=true;
         
         this.userdata.username=form.value.fullname;
         this.userdata.email=form.value.email;
          this.userdata.education=form.value.education;
          this.userdata.mobile_no=form.value.mobile_no;
         this.userdata.birthDate=form.value.birthDate;
         this.userdata.totalexp=form.value.total_exp;
         this.userdata.current_ctc=form.value.current_ctc;
         this.userdata.expect_ctc=form.value.expect_ctc;
         this.userdata.notice_period=form.value.notice_period;
         this.userdata.skill1=form.value.skill1;
         this.userdata.skill_rating1=form.value.skill_rating1;
          this.userdata.skill2=form.value.skill2;
         this.userdata.skill_rating2=form.value.skill_rating2;
          this.userdata.skill3=form.value.skill3;
         this.userdata.skill_rating3=form.value.skill_rating3;
          this.userdata.skill4=form.value.skill4;
         this.userdata.skill_rating4=form.value.skill_rating4;
          this.userdata.skill5=form.value.skill5;
         this.userdata.skill_rating5=form.value.skill_rating5;
         this.userdata.gender=form.value.gender;
         this.userdata.question1=form.value.job_change;
         this.userdata.question2=form.value.tell_us;
        console.log("userdatavalue"+this.userdata);
            console.log("userdatavalue"+this.userdata.skill_rating1);
          
             this._service.u_userdata=this.userdata;


            this._service.setValue('username', this.userdata.username);
            this._service.setValue('email', this.userdata.email);
           this._service.setValue('education', this.userdata.education);
            this._service.setValue('mobile_no', this.userdata.mobile_no);
            this._service.setValue('birthDate', this.userdata.birthDate);
            this._service.setValue('totalexp', this.userdata.totalexp);
            this._service.setValue('current_ctc', this.userdata.current_ctc);
            this._service.setValue('expect_ctc', this.userdata.expect_ctc);
            this._service.setValue('notice_period', this.userdata.notice_period);
            this._service.setValue('skill1', this.userdata.skill1);
            this._service.setValue('skill_rating1', this.userdata.skill_rating1);
                this._service.setValue('skill2', this.userdata.skill2);
            this._service.setValue('skill_rating2', this.userdata.skill_rating2);
             this._service.setValue('skill3', this.userdata.skill3);
            this._service.setValue('skill_rating3', this.userdata.skill_rating3);
            this._service.setValue('skill4', this.userdata.skill4);
            this._service.setValue('skill_rating4', this.userdata.skill_rating4);
            this._service.setValue('skill5', this.userdata.skill5);
            this._service.setValue('skill_rating5', this.userdata.skill_rating5);
            this._service.setValue('gender', this.userdata.gender);
            this._service.setValue('question1', this.userdata.question1);
            this._service.setValue('question2', this.userdata.question2);

            this._service.sendUserData().subscribe(response=> this.get_data=response);

                     
              
           
         form.value.fullname='';
        form.value.email='';
        form.value.education='';
        form.value.mobile_no='';
        form.value.birthDate='';
        form.value.total_exp='';
         form.value.current_ctc='';
        form.value.expect_ctc='';
        form.value.notice_period='';
         form.value.skill1='';
        form.value.skill_rating1='';
       form.value.skill2='';
        form.value.skill_rating2='';
        form.value.skill3='';
        form.value.skill_rating3='';
        form.value.skill4='';
        form.value.skill_rating4='';
         form.value.skill5='';
        form.value.skill_rating5='';
         form.value.gender='';
        form.value.job_change='';
        form.value.tell_us='';
        
    }



  
}    



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/newinterviewreview/newinterviewreview.component.ts